import http from '../http'
import { Res } from '../type'
import { CommunityBoardContentDeleteParams } from '../Models/CommunityBoardContentDelete'
import { CommunityBoardContent, CommunityBoardContentParams } from '../Models/CommunityBoardContent'
import { CommunityTopContent, CommunityTopContentParams } from '../Models/CommunityTopContent'
import { CommunityBoardKeepTopParams } from '../Models/CommunityBoardKeepTop'
import { CommunityPublishContent, CommunityPublishContentParams } from '../Models/CommunityPublishContent'
import { CommunityHomeData, CommunityHomeDataParams } from '../Models/CommunityHomeData'
import { CommunityBanners } from '../Models/CommunityBanners'
import { CommunityBoards, CommunityBoardsParams } from '../Models/CommunityBoards'
import { CommunityBoardDetail, CommunityBoardDetailParams } from '../Models/CommunityBoardDetail'
import { CommunityBoardNames } from '../Models/CommunityBoardNames'
import { CommunityBoardMasters, CommunityBoardMastersParams } from '../Models/CommunityBoardMasters'
import { CommunityBoardContentList, CommunityBoardContentListParams } from '../Models/CommunityBoardContentList'
import { CommunitySearch } from '../Models/CommunitySearch'
import { CommunityKeepTopParams } from '../Models/CommunityKeepTop'

// 社区相关接口（学员端）-社区首页(H5专用)
export const getCommunityHomeData = (params: CommunityHomeDataParams): Res<CommunityHomeData> => {
  return http.request({
    url: '/sands-lms/api/v1/community/index',
    method: 'get',
    params,
    loadingShow: params.loadingShow
  })
}

// 社区相关接口（学员端）-我的发布(分页)

export const getMyPublishList = (params: {
  size: number
  current: number
  terminalType: number
}): Res<CommunityBoardContentList> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/publish/page',
    method: 'post',
    data: params,
    loadingShow: '0'
  })
}

// 社区相关接口（学员端）-查询当前学院的社区banner
export const getCommunityBanners = (): Res<CommunityBanners> => {
  return http.request({
    url: '/sands-lms/api/v1/community/banner/list',
    method: 'get'
  })
}

// 社区相关接口（学员端）-专栏板块(分页)
export const getCommunityBoards = (params: CommunityBoardsParams): Res<CommunityBoards> => {
  return http.request({
    url: '/sands-lms/api/v1/community/board/column/page',
    method: 'post',
    data: params,
    loadingShow: params.loadingShow
  })
}

// 社区相关接口（学员端）-社区板块详情
export const getCommunityBoardDetail = (params: CommunityBoardDetailParams): Res<CommunityBoardDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/community/board/get',
    method: 'get',
    params,
    loadingShow: params.loadingShow
  })
}

// 社区相关接口（学员端）-查询社区所有板块-版主关系(分页)
export const getCommunityBoardMasters = (params: CommunityBoardMastersParams): Res<CommunityBoardMasters> => {
  return http.request({
    url: '/sands-lms/api/v1/community/board-moderator/page',
    method: 'post',
    data: params
  })
}

// 社区相关接口（学员端）-查询社区板块(分页)(创建帖子、文章、图册用)
export const getCommunityBoardNames = (): Res<CommunityBoardNames> => {
  return http.request({
    url: '/sands-lms/api/v1/community/board/name',
    method: 'get',
    loadingShow: '0'
  })
}
// 社区相关接口（学员端）-查询社区所有板块内容(分页)
export const getCommunityBoardContentList = (
  params: CommunityBoardContentListParams
): Res<CommunityBoardContentList> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/page',
    method: 'post',
    data: params,
    loadingShow: params.loadingShow ? (params.loadingShow as '0' | '1' | undefined) : '0'
  })
}

// 社区相关接口（学员端）-创建社区板块内容（发帖/写文章/传图册）
export const postCommunityPublishContent = (data: CommunityPublishContentParams): Res<CommunityPublishContent> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/create',
    method: 'post',
    data
  })
}

// 社区相关接口（学员端）-修改社区板块内容（发帖/写文章/传图册
export const postCommunityUpdateContent = (data: CommunityPublishContentParams): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/update',
    method: 'post',
    data
  })
}

// 社区相关接口（学员端）-获取社区板块内容详情
export const getCommunityBoardContent = (params: CommunityBoardContentParams): Res<CommunityBoardContent> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/get',
    method: 'get',
    params,
    loadingShow: (params.loadingShow as '0' | '1' | undefined) || '0',
    toastShow: params.toastShow
  })
}
// 社区相关接口（学员端）-获取社区板块内容详情-允许未登录-app分享预览
export const getByShareVideo = (params: CommunityBoardContentParams): Res<CommunityBoardContent> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/getByShare',
    method: 'get',
    params,
    loadingShow: (params.loadingShow as '0' | '1' | undefined) || '0',
    toastShow: params.toastShow
  })
}
// 社区相关接口（学员端）-删除社区板块内容
export const postCommunityBoardContentDelete = (params: CommunityBoardContentDeleteParams): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/delete',
    method: 'POST',
    data: params,
    loadingShow: params.loadingShow
  })
}
// 社区相关接口（学员端）-热门内容查询
export const postCommunitySearch = (): Promise<CommunitySearch> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/hot/list',
    method: 'post'
  })
}
// 社区相关接口（学员端）-设置全局置顶
export const postCommunityKeepTop = (params: CommunityKeepTopParams): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/top/global',
    method: 'POST',
    data: params,
    loadingShow: params.loadingShow
  })
}

// 社区相关接口（学员端）-获取置顶区内容
export const getCommunityTopContent = (params: CommunityTopContentParams): Res<CommunityTopContent[]> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/top/list',
    method: 'get',
    params,
    loadingShow: '0'
  })
}
// 社区相关接口（学员端）-设置版内置顶
export const postCommunityBoardKeepTop = (params: CommunityBoardKeepTopParams): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/community/content/top/board',
    method: 'POST',
    data: params,
    loadingShow: params.loadingShow
  })
}
